import { defaultReturn, generateDefaultActions, makeWritePayload } from "shared-utility/store/utils/helpers";

const initialState = {
  selectedLoansForDY: [],
  debtYieldReportComponent: null,
  debtYieldCalculations: null,
  totalDebtYieldValue: null
};

export const SET_DEBT_YIELD_SETUP_SELECTIONS = generateDefaultActions("SET_DEBT_YIELD_SETUP_SELECTIONS");
export const setDebtYieldSetupSelections = payload => makeWritePayload(SET_DEBT_YIELD_SETUP_SELECTIONS.value, payload);

export const SET_DY_SETUP_TO_DEFAULT = generateDefaultActions("SET_DY_SETUP_TO_DEFAULT");
export const setDYSetupToDefault = () => makeWritePayload(SET_DY_SETUP_TO_DEFAULT.value, initialState);

export const actionCreators = {
  setDebtYieldSetupSelections,
  setDYSetupToDefault
};


export const lenderReportsDebtYieldSetupReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_DEBT_YIELD_SETUP_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_DY_SETUP_TO_DEFAULT.value:
      return defaultReturn({ ...payload });
    default:
      return state;
  }
};
